"use client";

import { useEffect } from "react";

/**
 * BodyOnLight — toggles `jess-on-light` on <body> while mounted.
 *
 * The shared glass-pill nav (.jess-glass-nav--desktop) relies on
 * this class for its light-section colour overrides (dark text,
 * subtle border, dark hover tint).  JessExperience also sets the
 * class on /jess; this component is for any other route that
 * wants the same light-section theming for the shared nav.
 */
export default function BodyOnLight() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.body.classList.add("jess-on-light");
    return () => document.body.classList.remove("jess-on-light");
  }, []);
  return null;
}
